<!---------------Header----------------------------->
<div class="col-12 px-0">
    <div class="bankHeaderBlock d-flex flex-wrap align-items-center">
        <div class="col d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <div *ngIf="commonServices.userLogedIn"><img (click)="appComp.openRatingPopup()" class="cursorPointer feedbackIcon" src="assets/images/icons/feedbackIcon.png" alt="feedbackIcon"></div>
                <a (click)="clickTrack('openFaqPage','click')" href="https://www.indusind.bank.in/in/en/personal/faq.html#Indus-Mobile-Credit-Card" target="_blank">
                    <img src="assets/images/icons/question-mark.svg" alt="help" class="logoutIcon cursorPointer" style="margin-left: 0 !important;">
                </a>
                <div *ngIf="commonServices.userLogedIn"><span  (click)="openLogoutPopup();clickTrack('openLogoutPopup','click')"><img src="assets/images/icons/logoutIcon.svg" alt="logoutIcon" class="logoutIcon cursorPointer"></span></div>
            </div>
                        <img alt="bankLogo" src="assets/images/logo/logo.svg" class="headerLogo">
            <!-- <div>
                <img  (click)="app.openLanguagePopup()" src="assets/images/icons/question-mark.svg" alt="langIcon"> 
            </div> -->
        </div>
    </div>
</div>

<ng-template #logoutConfirmation let-modal>
    <div class="modal-body px-0 py-0">
        <div class="modalLogoutWrapper">
            <div class="text-end">
                <img class="cursorPointer" (click)="logoutRef.close()" src="assets/images/icons/crossIcon.png"
                    alt="crossIcon" width="15" height="auto">
            </div>
            <div class="d-flex justify-content-center mt-2 mb-4"><img class="logoutPopupBanner" alt="logoutPopupImg" src="assets/images/banners/logoutPopupImg.png"></div>
            <div class="text-center" *ngIf="!commonServices.showLimitDataSaveBtn && !commonServices.showManageDataSaveBtn">Are you sure you want to Logout?</div>
            <div class="text-center" *ngIf="commonServices.showLimitDataSaveBtn || commonServices.showManageDataSaveBtn">There are unsaved changes, save them before you Logout.</div>
            <div class="d-flex justify-content-around mt-4">
                <div *ngIf="commonServices.showLimitDataSaveBtn || commonServices.showManageDataSaveBtn" class="cardEnableBtn setBtn d-flex justify-content-center align-items-center"
                    (click)="saveSetupOnLogout();clickTrack('Save&Logout-LogoutSession-header','click')">
                    Save & Logout
                </div>
                <div [ngClass]="{'cardEnableBtn2' : commonServices.showLimitDataSaveBtn || commonServices.showManageDataSaveBtn }" class="cardEnableBtn setBtn d-flex justify-content-center align-items-center"
                    (click)="logoutUser('Yes');clickTrack('Logout-LogoutSession-header','click')">
                    Logout
                </div>
                <div *ngIf="!commonServices.showLimitDataSaveBtn && !commonServices.showManageDataSaveBtn" class="cardEnableBtn2 setBtn d-flex justify-content-center align-items-center"
                    (click)="logoutUser('No');clickTrack('Cancel-logoutSession-header','click')">
                    Cancel
                </div>
            </div>
        </div>
    </div>
</ng-template>